import type { SOIL_VARIABILITY_LEVEL } from "./soilMapAnalysisTypes";
import {
  getColorForNDVIValue as getColorForNDVIValueUtil,
  getDefaultColorPaletteValue as getDefaultColorPaletteValueUtil,
  getAccessibilityPaletteValue as getAccessibilityPaletteValueUtil,
} from "./soilColorUtil";

export function getColorForNDVIValue(value: number): string {
  return getColorForNDVIValueUtil(value);
}

export function getVariabilityTagType(value: number): SOIL_VARIABILITY_LEVEL {
  value = Math.max(0, Math.min(1, value));

  if (value >= 0.65) {
    return "HIGH";
  } else if (value >= 0.6) {
    return "MEDIUM";
  } else {
    return "LOW";
  }
}

export function getDefaultColorPaletteValue(
  position: number,
  numberOfZones: number
): string {
  return getDefaultColorPaletteValueUtil(position, numberOfZones);
}

export function getAccessibilityPaletteValue(
  position: number,
  numberOfZones: number
): string {
  return getAccessibilityPaletteValueUtil(position, numberOfZones);
}
